const click = ({
  carouselKey,
  siteName,
  action,
  carouselName,
  pageName,
  skuId,
  podPositionInCarousel,
  lengthPodsInCarousel,
  slotId,
}) => {
  const recoClickEvent = new CustomEvent('DDMCrossRecoClick', {
    detail: {
      carouselKey,
      siteName,
      action,
      carouselName,
      pageName,
      skuId,
      podPositionInCarousel,
      podsInCarousel: Array(lengthPodsInCarousel),
      slotId,
    },
  });
  window.dispatchEvent(recoClickEvent);
};

const impression = ({ carouselName, skusViewed, driverVariantId }) => {
  const recoImpressionEvent = new CustomEvent('DDMCrossRecoImpression', {
    detail: {
      carouselName,
      skusViewed,
      driverVariantId,
    },
  });
  window.dispatchEvent(recoImpressionEvent);
};

export const recoAnalytics = {
  click,
  impression,
};

export const carouselActions = {
  clickToRate: 'CTR',
  addToCart: 'A2C',
};
